/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */
import React, {useEffect, useState} from 'react';
import ButtonComponent from "../BasicInputs/ButtonComponent.jsx";
import TableSearch from "../PageComponents/TableSearch.jsx";
import TextInputFormComponent from "../FormComponents/TextInputFormComponent.jsx";
import CardsSelectFormComponent from "../FormComponents/CardsSelectFormComponent.jsx";
import InputWithButton from "../BasicInputs/InputWithButton.jsx";
import RowDataTable from "../RowDataTable.jsx";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import IconButtonComponent from "../BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "../EmptyState/EmptyStateBig.jsx";
import UsersAPI from "authClient/usersApi";
import InlineDialog from "../InlineDialog.jsx";

const preFillDataStructure = {
    "firstName": "",
    "surname": "",
    "email": "",
    "temporaryPassword": "",
    "role": "user",
    "newPassword": "",
    "isPermanent": false,
}

export const UserManagementSettings = ({}) => {
    const [searchInput, setSearchInput] = useState("");
    const [tenantUsers, setTenantUsers] = useState([]);
    const [isAddUserOpen, setIsAddUserOpen] = useState(false);
    const [isEditUserOpen, setIsEditUserOpen] = useState(false);
    const [addUserState, setAddUserState] = useState({...preFillDataStructure});
    const [editUserState, setEditUserState] = useState({...preFillDataStructure});
    const [addUserError, setAddUserError] = useState(null);
    const [editUserError, setEditUserError] = useState(null);

    const createNewUser = () => {
        setAddUserState({...preFillDataStructure});
        setAddUserError(null);
        setIsAddUserOpen(true);
    }

    const fetchData = async () => {
        let data = await UsersAPI.list()
        if (data?.error !== true) {
            setTenantUsers(data)
        }
    }

    const displayDrawer = (drawerTyp, state, setState) => {
        switch (drawerTyp) {
            case "addNew":
                return (<>
                    <div className={"mt-2 space-y-3"}>
                        <TextInputFormComponent name={"Vorname"} value={state.firstName}
                                                onChange={event => {
                                                    setState(prev => ({...prev, firstName: event}))
                                                }}/>
                        <TextInputFormComponent name={"Nachname"} value={state.surname}
                                                onChange={event => {
                                                    setState(prev => ({...prev, surname: event}))
                                                }}/>
                        <TextInputFormComponent name={"Email"} value={state.email}
                                                onChange={event => {
                                                    setState(prev => ({...prev, email: event}))
                                                }}/>
                        <CardsSelectFormComponent
                            value={state.role}
                            name={"role"}
                            options={[
                                {label: "user - can edit", value: "user"},
                                {label: "admin - full control", value: "admin"},
                            ]}
                            onChange={event => {
                                setState(prev => ({...prev, role: event}))
                            }}
                        />
                        <InputWithButton name={"Password"}
                                         value={state.temporaryPassword}
                                         onChange={event => {
                                             setState(prev => ({...prev, temporaryPassword: event}))
                                         }}
                                         iconName={"IoRefresh"}
                                         onClick={() => {
                                             let length = 12,
                                                 charset = "abc%9defgA!hijktmn!opqrs12tuvw7xyzABCDEFGHIJ%KLMNOPQRST!UVW54§XYZ0123456!789ATCTLTß8HL3O§PT",
                                                 retVal = "";
                                             for (let i = 0, n = charset.length; i < length; ++i) {
                                                 retVal += charset.charAt(Math.floor(Math.random() * n));
                                             }
                                             setState(prev => ({...prev, temporaryPassword: retVal}))
                                         }}
                        />
                    </div>
                </>)
            case "edit":
                return (<>
                    <div className={"mt-2 space-y-3"}>
                        <TextInputFormComponent name={"Vorname"} value={state.firstName}
                                                onChange={event => {
                                                    setState(prev => ({...prev, firstName: event}))
                                                }}/>
                        <TextInputFormComponent name={"Nachname"} value={state.surname}
                                                onChange={event => {
                                                    setState(prev => ({...prev, surname: event}))
                                                }}/>
                        <TextInputFormComponent name={"Email"} value={state.email}
                                                onChange={event => {
                                                    setState(prev => ({...prev, email: event}))
                                                }}/>
                        <CardsSelectFormComponent
                            value={state.role}
                            name={"role"}
                            options={[
                                {label: "user - can edit", value: "user"},
                                {label: "admin - full control", value: "admin"},
                            ]}
                            onChange={event => {
                                setState(prev => ({...prev, role: event}))
                            }}
                        />
                        <ButtonComponent
                            iconName={((state.setNewPassword) ? ("Check") : ("IoRefresh"))}
                            text={"Set User Password"} onClick={() => {
                            setState(prev => ({...prev, setNewPassword: !prev.setNewPassword}))
                        }}/>
                        {state.setNewPassword && (<>
                            <InputWithButton name={"newPassword"}
                                             value={state.newPassword}
                                             onChange={event => {
                                                 setState(prev => ({...prev, newPassword: event}))
                                             }}
                                             iconName={"IoRefresh"}
                                             onClick={() => {
                                                 let length = 12,
                                                     charset = "abc%9defgA!hijktmn!opqrs12tuvw7xyzABCDEFGHIJ%KLMNOPQRST!UVW54§XYZ0123456!789ATCTLTß8HL3O§PT",
                                                     retVal = "";
                                                 for (let i = 0, n = charset.length; i < length; ++i) {
                                                     retVal += charset.charAt(Math.floor(Math.random() * n));
                                                 }
                                                 setState(prev => ({...prev, newPassword: retVal}))
                                             }}
                            />
                        </>)}
                        <br/>
                        <div className={"h-4"}/>
                        <ButtonComponent text={"Delete User "}
                                         iconName={((state.deleteUser) ? ("Check") : ("IoTrashOutline"))}
                                         onClick={() => {
                                             setState(prev => ({...prev, deleteUser: !prev.deleteUser}))
                                         }}/>
                        <br/>
                        <br className={"h-4"}/>
                    </div>
                </>)
            default:
                return <div/>
        }
    }

    useEffect(() => {
        fetchData()
    }, []);

    const handleEditUser = (data) => {
        setEditUserState({...data});
        setEditUserError(null);
        setIsEditUserOpen(true);
    }

    return (
        <>
            <ButtonComponent
                text={"Add new User"}
                iconName={"PiUserPlus"}
                onClick={createNewUser}
            />

            <InlineDialog
                title={"Add new User"}
                isOpen={isAddUserOpen}
                button={[{
                    type: "save", text: "Create User", onClick: async (state, setState, close) => {
                        setAddUserError(null);
                        let data = await UsersAPI.create(addUserState.firstName, addUserState.surname, addUserState.email, addUserState.role, addUserState.temporaryPassword)
                        if (data.state === "UserCreated") {
                            setIsAddUserOpen(false);
                        } else {
                            setAddUserError(data.message);
                        }

                        await fetchData()

                    }
                }, {
                    type: "abort",
                    text: "Abbrechen",
                    onClick: (inputState, setState, close) => {
                        setIsAddUserOpen(false);
                    }
                }]}
                onClose={() => {
                    setIsAddUserOpen(false);
                }}>
                <div>

                    {displayDrawer("addNew", addUserState, setAddUserState)}
                    {addUserError && (
                        <div className="text-red-500 mb-2 bg-red-100 p-2 rounded-lg mt-10">{addUserError}</div>
                    )}
                </div>
            </InlineDialog>

            <InlineDialog
                title={"Edit User"}
                isOpen={isEditUserOpen}
                button={[{
                    type: "save",
                    text: "Save",
                    onClick: async (state, setState, close) => {
                        let hasError = false;
                        setEditUserError(null);

                        if (editUserState.setNewPassword) {
                            let result = await UsersAPI.setPassword(editUserState.userId, editUserState.newPassword)
                            if (result.state !== "passwordChanged") {
                                hasError = true;
                                setEditUserError(result.message);
                            }
                        }

                        if (editUserState.deleteUser) {
                            let result = await UsersAPI.remove(editUserState.userId)
                            if (result.state !== "UserDeleted") {
                                hasError = true;
                                setEditUserError(result.message);
                            }
                        } else {
                            let result = await UsersAPI.update(editUserState.firstName, editUserState.surname, editUserState.userId, editUserState.email, editUserState.role)
                            if (result.state !== "UserUpdated") {
                                hasError = true;
                                setEditUserError(result.message);
                            }
                        }

                        await fetchData()
                        if (hasError === false) {
                            setIsEditUserOpen(false);
                        }
                    }
                }, {
                    type: "abort",
                    text: "Abbrechen",
                    onClick: (inputState, setState, close) => {
                        setIsEditUserOpen(false);
                    }
                }]}
                onClose={() => {
                    setIsEditUserOpen(false);
                }}>
                <div>
                    {editUserError && (
                        <div className="text-red-500 mb-2">{editUserError}</div>
                    )}
                    {displayDrawer("edit", editUserState, setEditUserState)}
                </div>
            </InlineDialog>

            <div className="mt-6">
                <div style={{minHeight: "80vh"}}>
                    <div style={{border: "10px"}}>
                        <TableSearch
                            placeholder={`Suchen in Nutzer`}
                            preSelectedColumn={"email"}
                            OnSearchInput={(value) => setSearchInput(value)}
                        />

                        <RowDataTable
                            selectedIndex={null}
                            iconElement={(row) => (
                                <div
                                    className={`shrink-0 w-7 h-7 flex justify-center items-center rounded-sm border mr-3`}>
                                    <DisplayIcon iconName={"PiUser"}/>
                                </div>
                            )}
                            buttons={(row) => (
                                <IconButtonComponent
                                    text={`Edit User`}
                                    iconName={"Edit"}
                                    onClick={async () => handleEditUser(row)}/>
                            )}
                            emptyState={() => (
                                <EmptyStateBig
                                    iconName={"Search"}
                                    text={<div className={"w-96 space-y-3"}>
                                        <div>
                                            Keine User mit dem Namen:
                                            "<span className={"italic"}>{searchInput}</span>" gefunden
                                        </div>
                                    </div>} children={undefined}/>
                            )}
                            data={tenantUsers.filter(name => Object.values(name).join(",").toString().includes(searchInput)
                            ).map(user => {
                                return {
                                    ...user,
                                    Name: <>{user.firstName} {user.surname} <UserRoleBadge user={user}/></>
                                };
                            })}
                            onRowClicked={handleEditUser} iconName={undefined} onMiddleMouseClick={undefined}/>
                    </div>
                </div>
            </div>
        </>
    );
}

const UserRoleBadge = ({user}) => {
    const getRoleStyle = (role) => {
        switch (role?.toLowerCase()) {
            case 'admin':
                return 'bg-green-100 text-green-500';
            case 'user':
                return 'bg-blue-100 text-blue-500';
            default:
                return 'bg-gray-100 text-gray-500';
        }
    };

    return (
        <span className={`p-1 ml-4 text-xs rounded-md ${getRoleStyle(user.role)}`}>
      {user.role}
    </span>
    );
}
